// extracted by mini-css-extract-plugin
export var carrierIcon = "_w5-0";
export var carrierLogo = "_w5-1";
export var detailsSection = "_w5-2";